// La URL del backend se inyecta en build time: CRA solo expone las vars REACT_APP_*
// y las reemplaza literalmente en el bundle, no se leen en runtime.
// Vacia = mismo origen, que es como corre en produccion (el backend sirve la SPA).
const API_URL = process.env.REACT_APP_API_URL ?? "";

export { API_URL };
